/**
 * Cloud access for `connected_wallets` <- localStorage
 * `mycryptoplanner_connected_wallets`.
 *
 * The `network` column has a CHECK (network in
 * ('ethereum','bitcoin','solana','bnb','polygon')). The app's
 * `ConnectedWallet.network` is the `NetworkId` literal union with exactly those
 * five members, so stored values already match — no transform needed.
 * `balances` (WalletBalance[]) goes into the JSONB column as-is.
 */
import type { ConnectedWallet, WalletBalance } from '../../types';
import type { ConnectedWalletRow } from './rows';
import { makeAppendTable } from './client';

function toRow(w: ConnectedWallet, userId: string): ConnectedWalletRow {
  return {
    id: w.id,
    user_id: userId,
    network: w.network, // NetworkId — matches CHECK exactly
    address: w.address,
    connected_at: w.connectedAt,
    last_synced: w.lastSynced,
    balances: w.balances,
    total_value_usd: w.totalValueUsd,
  };
}

function fromRow(row: ConnectedWalletRow): ConnectedWallet {
  return {
    id: row.id,
    network: row.network,
    address: row.address,
    connectedAt: Number(row.connected_at),
    lastSynced: row.last_synced == null ? null : Number(row.last_synced),
    balances: (row.balances ?? []) as WalletBalance[],
    totalValueUsd: Number(row.total_value_usd),
  };
}

export const connectedWalletsTable = makeAppendTable<ConnectedWallet, ConnectedWalletRow>(
  'connected_wallets',
  toRow,
  fromRow
);
